/**
 * Build-time feature switches that default OFF.
 *
 * Vite inlines `import.meta.env` when the bundle is built, so each flag is resolved once at
 * module load and changing one means setting the Vercel variable and redeploying. Kept out of
 * `routes.tsx` so pages can read a flag without importing the route table.
 */

/**
 * Parses an opt-in switch: ON only for the word "true" in any letter case. Unset, blank or any
 * other spelling ("1", "on", "yes") is OFF. This is the same rule the backend applies to its
 * `ENABLE_*` settings (`os.getenv(...).lower() == "true"`), so the two halves of a switch never
 * disagree about one value.
 */
export function parseOptInFlag(raw: string | undefined): boolean {
  return typeof raw === "string" && raw.toLowerCase() === "true";
}

/**
 * Request a Song — ARCHIVED (owner decision, 2026-10-12). Front half of the backend
 * `ENABLE_SONG_REQUESTS` switch, which answers 410 on POST /api/song-requests while off.
 *
 * Off: `/request-song` shows a "paused" notice, and the Home "Sync anything" card and the Help
 * Center answer that point to it are hidden. The page, `lib/song-requests.ts` and every existing
 * request (under /licenses) are untouched. To restore, turn the backend switch on first, then set
 * `VITE_SONG_REQUESTS_ENABLED=true` and redeploy, so the form never shows while the API refuses it.
 */
export const SONG_REQUESTS_ENABLED = parseOptInFlag(
  import.meta.env.VITE_SONG_REQUESTS_ENABLED as string | undefined
);
